import { render, staticRenderFns } from "./IconLinkedIn.vue?vue&type=template&id=5ad42206&"
import script from "./IconLinkedIn.vue?vue&type=script&lang=ts&"
export * from "./IconLinkedIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports